import React from 'react';
import { Wrapper } from 'AppReact';;
import styled from 'styled-components';
import device from 'utils/device'

const template = styled.div`
    @media ${device.tablet} {
        display: flex;
        justify-content: center;
        gap: 10px;
    }
`
export default Wrapper(template)
